/**
 * @generated SignedSource<<63e4076332962020ae45ece263c38c8b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsContent_paymentAddresses$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_paymentAddresses">;
  readonly " $fragmentType": "SplitDetailsContent_paymentAddresses";
};
export type SplitDetailsContent_paymentAddresses$key = {
  readonly " $data"?: SplitDetailsContent_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_paymentAddresses">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsContent_paymentAddresses",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSplit_paymentAddresses"
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};

(node as any).hash = "d499565d2a73e8197e4f5974ad8242e5";

export default node;
